import { datadogLogs } from "@datadog/browser-logs";
import "@dopplexr/editor/lib/connectors/opfs.ts";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./style.css";
import "./styles/naive-ui-overrides.css";

navigator.serviceWorker.getRegistrations()?.then((registrations) => {
	for (const registration of registrations) {
		registration.unregister();
	}
});

if (!localStorage.getItem("ROARR_LOG")) {
	localStorage.setItem("ROARR_LOG", "true");
}

const dataDogClientToken = import.meta.env.VITE_APP_DATADOG_API_KEY;

if (dataDogClientToken) {
	datadogLogs.init({
		clientToken: dataDogClientToken,
		site: "datadoghq.com",
		service: "prototype",
		forwardErrorsToLogs: true,
		sessionSampleRate: 100,
	});
}

const app = createApp(App)
	.use(PrimeVue, {
		theme: "none",
	})
	.use(createPinia())
	.use(router);

router.isReady().then(() => {
	app.mount("#app");
});
